import { browserHistory } from 'react-router';
import { copy } from 'redux-clipboard-copy';

import * as types from '../constants/ActionTypes';
import * as endPoints from '../constants/EndPoints';
import * as actionsAlerts from './AlertsActions';
import actionsAlertsValves, { setDefFilters as setValveDefFilters, setFilters as setValveFilters } from './AlertsValveActions';
import actionsAlertsBurst, { setDefFilters as setBurstDefFilters, setFilters as setBurstFilters } from './AlertsBurstActions';
import * as actionsCouples from './CouplesActions';
import * as actionsCustomers from './CustomersActions';
import * as actionsInspect from './InspectActions';
import * as actionsInterferences from './InterferencesActions';
import * as actionsUsers from './ManageActions';
import { handleLayerChange } from './MapActionsHandler';
import { fetchMiddleware, getIconFeatures, setIndexes } from './MiddlewareActions';
import * as actionsMobileAlerts from './MobileAlertsActions';
import * as actionsMobileTasks from './MobileTasksActions';
import * as actionsNoiseAlerts from './NoiseAlertsActions';
import * as actionsProjects from './ProjectsActions';
import * as actionsPressureAlerts from './PrsTransientAlertsActions';
import * as actionsSensors from './SensorsActions';
import * as actionsSOPs from './SOPsActions';
import * as geocoder from './Utilities/geocoder';

import * as reduxFormActions from 'redux-form';
import { featuresTypes } from '../components/Map/Layers/Options';
import {
  FILTERS_ALERTS,
  FILTERS_COUPLES,
  FILTERS_NOISE_ALERTS,
  FILTERS_SENSORS,
  FILTERS_SOPS,
  FILTERS_VALVE_ALERTS,
  FILTERS_BURST_ALERTS,
  FILTERS_MOBILE_ALERTS,
  SORT_ALERTS,
} from '../constants/SettingsKeys';
import { resolveBurstDefaultAlertStates } from '../utils/burstAlerts';
import { handlePathChangeEvent } from "./actions";
import * as selectorsActions from "./selectors";
import { setFieldText, setMapDrawMode } from "./setters";

const hasMeaningfulValue = (value) => {
  if (value == null) {
    return false;
  }
  if (typeof value === 'string') {
    return value.trim().length > 0;
  }
  return true;
};

const upsertRangeFilter = (filters, field, fromValue, toValue) => {
  const hasFrom = hasMeaningfulValue(fromValue);
  const hasTo = hasMeaningfulValue(toValue);

  if (!hasFrom && !hasTo) {
    return;
  }

  const filterIndex = filters.map((item) => item.field).indexOf(field);
  const rangeFilter = {
    field,
    op: 'range',
    from: hasFrom ? fromValue : false,
    to: hasTo ? toValue : false,
  };

  if (filterIndex === -1) {
    filters.push(rangeFilter);
  } else {
    filters[filterIndex] = rangeFilter;
  }
};

const mapAbcValuesToLabels = (selectedValues, abcOptions = []) => {
  if (!Array.isArray(selectedValues)) {
    return selectedValues;
  }

  return selectedValues.map((selectedValue) => {
    const matchingOption = abcOptions.find(
      (option) => String(option.value) === String(selectedValue)
    );

    return matchingOption
      ? matchingOption.DisplayName || matchingOption.label
      : selectedValue;
  });
};

export const onPathChange = (prevPath, nextPath) => (dispatch, getState) => {
  const state = getState();
  const selectedProject = state.leaksList.selectedProject;
  const selectedFeature = state.leaksList.leaksByProject.selectedFeature;

  dispatch(handlePathChangeEvent(selectedProject));

  if (
    ['alerts', 'couples', 'inspect'].indexOf(prevPath) > -1 &&
    ['alerts', 'couples'].indexOf(nextPath) > -1
  ) {
    if (selectedFeature != null && selectedFeature !== '') {
      const alertsItems = state.leaksList.leaksByProject[selectedProject].items;
      const alertsIndexMap =
        state.leaksList.leaksByProject[selectedProject].indexMap;
      const couplesItems =
        state.leaksList.leaksByProject[selectedProject].couples.couples;
      const couplesIndexMap =
        state.leaksList.leaksByProject[selectedProject].couples.indexMap;
      const alertsContext = state.leaksList.pressure.context;

      if (prevPath === 'alerts' && nextPath === 'couples') {
        if (alertsContext === 'alerts') {
          const selectedAlert = alertsItems[alertsIndexMap[selectedFeature]];
          if (
            selectedAlert != null &&
            couplesIndexMap[selectedAlert.CoupleID] != null
          ) {
            const relatedCouple =
              couplesItems[couplesIndexMap[selectedAlert.CoupleID]];
            dispatch(actionsCouples.selectCoupleOrAssessment(relatedCouple));
          }
        }
      } else if (prevPath === 'couples' && nextPath === 'alerts') {
        if (alertsContext === 'alerts') {
          let relatedAlert = null;
          for (let i = 0; i < alertsItems.length; i++) {
            const itrAlert = alertsItems[i];
            if (itrAlert.CoupleID === selectedFeature) {
              relatedAlert = itrAlert;
              break;
            }
          }
          if (relatedAlert != null) {
            dispatch(actionsAlerts.selectAlert(relatedAlert));
          }
        }
      } else if (prevPath === 'inspect' && nextPath === 'alerts') {
        // select the alert for view its details:
        const selectedAlert = alertsItems[alertsIndexMap[selectedFeature]];
        if (selectedAlert != null) {
          dispatch(actionsAlerts.selectAlert(selectedAlert));
        }
      }
    }
  }

  if (nextPath === 'inspect') {
    dispatch(actionsInspect.investigateAlerts(selectedProject));
    dispatch(actionsInspect.investigatePipes(selectedProject));
    // dispatch(actionsMapHandler.handleLayerChange(featuresTypes.PIPES_CONDITION_ASSESSMENTS, true));
    //dispatch(actionsMapHandler.handleLayerChange(featuresTypes.INSPECT_ALERTS, true));
  }
  // else if (prevPath == 'inspect') {
  // 	dispatch(actionsMapHandler.handleLayerChange(featuresTypes.PIPES_CONDITION_ASSESSMENTS, false));
  // }
  //else if (prevPath == 'inspect') {
  //   dispatch(actionsMapHandler.handleLayerChange(featuresTypes.INSPECT_ALERTS, false));
  // }
};
// @todo: need to figure how to resolve
export function setSelectedItem(item, onFail, additionalData) {
  return (dispatch, getState) => {
    const state = getState();
    const normalizedItem =
      item && item.ID ? { ...item, id: String(item.ID) } : item;
    const selectedFeatureID = state.leaksList.leaksByProject.selectedFeature;
    if (
      (normalizedItem == null && selectedFeatureID !== '') ||
      (normalizedItem != null && selectedFeatureID === '') ||
      (normalizedItem != null && normalizedItem.id != selectedFeatureID)
    ) {
      const path =
        state.routing.locationBeforeTransitions.pathname.replace('/', '') ||
        'alerts';
      switch (path) {

        case 'alerts': {
          const alertsContextMenu = state.leaksList.pressure.context;
          switch (alertsContextMenu) {
            case 'alerts':
              dispatch(actionsAlerts.selectAlert(normalizedItem));
              break;

            case 'prsAlerts':
              dispatch(actionsPressureAlerts.selectPressureAlert(normalizedItem));
              break;

            case 'noise':
              dispatch(actionsNoiseAlerts.selectNoiseAlert(normalizedItem));
              break;

            case 'valve':
              dispatch(actionsAlertsValves.selectValveAlert(normalizedItem));
              break;

            case 'burst':
              dispatch(actionsAlertsBurst.selectBurstAlert(normalizedItem));
              break;

            default:
              break;
          }
          break;
        }
        case 'sensors': {
          const selectedProjectId = state.leaksList.selectedProject;
          const sensorsContext = state.leaksList.leaksByProject[selectedProjectId]?.sensors?.sensorsContext;
          if (sensorsContext === 'PressureSensors') {
            dispatch(actionsSensors.selectPressureSensor(item));
          } else {
            dispatch(actionsSensors.selectSensor(item));
          }
          break;
        }
        case 'couples':
          if (item.type == 'sensor') {
            const selectedProjectId = state.leaksList.selectedProject;
            const sensorsBundle =
              state.leaksList.leaksByProject[selectedProjectId].sensors;
            const selectedSensor =
              sensorsBundle.sensors[sensorsBundle.indexMap[item.id]];
            if (selectedSensor == null) {
              // notify Filters...
              if (onFail != null) {
                onFail();
              }
            } else {
              const pathParams = {
                pathname: 'sensors',
                query: { project: selectedProjectId },
                state: { fromMap: true }, // flag for not clear the selected item on the reducer.
              };
              browserHistory.push(pathParams);

              dispatch(actionsSensors.selectSensor(selectedSensor));
            }
          } else {
            dispatch(actionsCouples.selectCoupleOrAssessment(item));
          }
          break;
        case 'manage':
          dispatch(selectManageItem(item));
          break;
        case 'install': {
          const installContext = state.install.installContext;
          switch (installContext) {
            case 'SOPs':
              dispatch(actionsSOPs.selectSOP(item));
              break;
            case 'Sensors':
              dispatch(actionsSensors.selectSensor(item));
              break;
            case 'PressureSensors':
              dispatch(actionsSensors.selectPressureSensor(item));
              break;
            case 'Interferences':
              dispatch(actionsInterferences.selectInterference(item));
              dispatch(setMapDrawMode(false));
              break;
            default:
              break;
          }
          break;
        }
        case 'mobile': {
          const mobileDisplayMode = state.mobile.modeState.mode;
          switch (mobileDisplayMode) {
            case 'Tasks':
              if (additionalData === 'multi') {
              }
              dispatch(
                actionsMobileTasks.setSelectedTask(
                  Array.isArray(item)
                    ? item.map((it) => it.task_uuid)
                    : item.task_uuid
                )
              );
              dispatch(handleLayerChange(featuresTypes.MOBILE_SAMPLES, true));
              break;

            case 'Alerts':
              dispatch(actionsMobileAlerts.selectMobileAlert(item));
              dispatch(handleLayerChange(featuresTypes.MOBILE_SAMPLES, true));
              break;
          }
          break;
        }
        default:
          break;
      }
    }
  };
}

export const selectManageItem = (item) => {
  return (dispatch, getState) => {
    const state = getState();
    const manageContext = state.manage.managementContext;

    switch (manageContext) {
      case 'Customers':
        dispatch(actionsCustomers.selectCustomer(item.ID));
        dispatch(actionsCustomers.loadDistributionLists(item.ID));
        // dispatch(actionsCustomers.loadUsersOfCustomer(item.ID));
        break;
      case 'Projects':
        dispatch(actionsProjects.selectProject(item.ID, true));
        dispatch(actionsProjects.viewProjectDetails(item.ID));
        //const projectCenter = this.props.selectedManageItem.editedCenter;
        break;
      case 'Users':
        dispatch(actionsUsers.viewUserDetails(item.UID));
        break;

      default:
        break;
    }
  };
};

export function addSingleFeature(project, feature, icon, type) {
  return (dispatch) => dispatch(addFeature(project, feature, icon, type));
}

function addFeature(project, feature, icon, featureType) {
  return {
    type: types.ADD_SINGLE_FEATURE,
    project,
    feature,
    icon,
    featureType,
  };
}
//--------------------------------
// Date
//--------------------------------
export function dateFields() {
  return [
    'TimeOfMaintenance',
    'detected',
    'DetectedAt',
    'fixDate',
    'ClosureDate',
    'DeviceInstallationDate',
    'LastActiveTime',
    'LastCommunicationTime',
    'SensorInstallationDate',
    'sampleTime',
  ];
}

export function isDateField(field) {
  return dateFields().indexOf(field) != -1;
}

// function formatDate(timestamp) {
//     var date = new Date(timestamp * 1000);
//     //return date.toLocaleDateString();
//     return date.toISOString().substr(0, 10);

// }

// function formatObjectsDate(objects) {
//     var df = dateFields();
//     objects.forEach(function (object) {
//         df.forEach(function (fieldKey) {
//             if (object && object.hasOwnProperty(fieldKey) && object[fieldKey] != null) {
//                 if (fieldKey == 'TimeOfMaintenance') {
//                     //debugger;
//                 }
//                 object[fieldKey] = formatDate(object[fieldKey]);
//             }
//         });
//     });
//     return objects;
// }

//--------------------------------
// Options
//--------------------------------

function receiveOptions(options, language) {
  return {
    type: types.RECEIVE_OPTIONS,
    options,
    language
  };
}

function requestOptions() {
  return {
    type: types.REQUEST_OPTIONS,
  };
}

// export function fetchOptionsIfNeeded() {
//   return (dispatch) => {
//     return dispatch(fetchOptions());
//   };
// }

export function fetchOptionsIfNeeded() {
  return (dispatch, getState) => {
    const state = getState();
    const chosenLanguage = state.i18nState.lang || 'en';
    const optionList = state.leaksList?.optionList;
    // Check if options are already fetched for the current language
    if (optionList && optionList.language === chosenLanguage) {
      return Promise.resolve(); // Options are up-to-date, no need to fetch
    }
    return dispatch(fetchOptions());
  };
}

export const fetchApiOptions = () => (dispatch, getState) => {
  const state = getState();
  const chosenLanguage = state.i18nState.lang || 'en';

  const path = `${endPoints.OPTIONS_ENDPOINT}?language=${chosenLanguage}`;

  dispatch(requestOptions());
  return fetchMiddleware(path, {}, getState).then((json) => {
    dispatch(receiveOptions(json.data, chosenLanguage));
    return json.data;
  })

}


export const fetchOptions = () => {
  return (dispatch, getState) => {
    dispatch(fetchApiOptions())
      .then((options) => {
        const state = getState();
        const urlPath =
          (state.routing.locationBeforeTransitions &&
            state.routing.locationBeforeTransitions.pathname.replace(
              '/',
              ''
            )) ||
          'alerts';
        let defaultFilters = [];
        let alertTypeDefaultFilters = [];
        options.AlertState.forEach((row) => {
          if (row.isDefault) {
            defaultFilters.push(row.value);
          }
        });
        options.AlertType.forEach((row) => {
          if (row.isDefault) {
            alertTypeDefaultFilters.push(row.value);
          }
        });
        //Set sort and filters
        if (urlPath == 'install') {
          dispatch(actionsSensors.setSensorsFilters([]));
          dispatch(
            actionsSensors.setSensorsDefFilters({
              sortBy: 'id',
              sortByDir: 'asc',
              SensorStatus: [],
            })
          );
        } else {
          let defSensorsStatusFilters = ['Ready', 'Active', 'Non Active'];
          let sensorsDefFilters = {
            sortBy: 'id',
            sortByDir: 'asc',
            SensorStatus: defSensorsStatusFilters,
          };
          let sensorsFilters = [
            { field: 'SensorStatus', value: defSensorsStatusFilters, op: '=' },
          ];
          if (localStorage[FILTERS_SENSORS]) {
            sensorsDefFilters = JSON.parse(
              localStorage.getItem(FILTERS_SENSORS)
            );
            sensorsFilters = [];
            Object.entries(sensorsDefFilters).forEach((filterEntry) => {
              if (
                [
                  'SensorStatus',
                  'SensorTypeValue',
                  'isUnderground',
                  'SyncMethodValue',
                  'DeviceGenerationValue',
                  'LastUninstallReason',
                  'G5DeviceType',
                  'Fragmented',
                  'Resets',
                ].indexOf(filterEntry[0]) !== -1
              ) {
                const filterObj = {
                  field: filterEntry[0],
                  value: filterEntry[1],
                };
                if (filterObj.field === 'LastUninstallReason') {
                  filterObj.avoidNulls = true;
                }
                sensorsFilters.push(filterObj);
              }
            });
          }
          dispatch(actionsSensors.setSensorsFilters(sensorsFilters));
          dispatch(actionsSensors.setSensorsDefFilters(sensorsDefFilters));
        }

        let sopsDefFilters = {};
        let sopsFilters = [];
        if (localStorage[FILTERS_SOPS]) {
          sopsDefFilters = JSON.parse(localStorage.getItem(FILTERS_SOPS));
          sopsFilters = [];
          Object.entries(sopsDefFilters).forEach((filterEntry) => {
            if (['sortBy', 'sortByDir', 'showRanking'].indexOf(filterEntry[0]) == -1) {
              sopsFilters.push({
                field: filterEntry[0],
                value: filterEntry[1],
              });
            }
          });
        }
        dispatch(actionsSOPs.setSopsDefFilters(sopsDefFilters));
        dispatch(actionsSOPs.setSopsFilters(sopsFilters));

        // dispatch(actionsSensors.sortSensors('id', 'asc'));
        // dispatch(actionsCouples.sortCouples('ID', 'asc'));
        let couplesDefFilters = { sortBy: 'id', sortByDir: 'asc' };
        let couplesFilters = [];
        if (localStorage[FILTERS_COUPLES]) {
          couplesDefFilters = JSON.parse(localStorage.getItem(FILTERS_COUPLES));
          couplesFilters = [];
          Object.entries(couplesDefFilters).forEach((filterEntry) => {
            if (['sortBy', 'sortByDir', 'showRanking'].indexOf(filterEntry[0]) == -1) {
              couplesFilters.push({
                field: filterEntry[0],
                value: filterEntry[1],
              });
            }
          });
        }
        dispatch(actionsCouples.setCouplesDefFilters(couplesDefFilters));
        dispatch(actionsCouples.setCouplesFilters(couplesFilters));

        if (localStorage[FILTERS_NOISE_ALERTS]) {
          const noiseAlertsDefFilters = JSON.parse(
            localStorage.getItem(FILTERS_NOISE_ALERTS)
          );
          const noiseAlertsFilters = [];

          Object.entries(noiseAlertsDefFilters).forEach((filterEntry) => {
            if (['sortBy', 'sortByDir', 'showRanking'].indexOf(filterEntry[0]) !== -1) {
              return;
            }

            switch (filterEntry[0]) {
              case 'InsertDate-To':
              case 'InsertDate-From': {
                const insertDateFilterIndex = noiseAlertsFilters
                  .map((item) => item.field)
                  .indexOf('InsertDate');
                const insertDateFilter =
                  insertDateFilterIndex !== -1
                    ? noiseAlertsFilters[insertDateFilterIndex]
                    : {};

                upsertRangeFilter(
                  noiseAlertsFilters,
                  'InsertDate',
                  filterEntry[0] === 'InsertDate-From'
                    ? filterEntry[1]
                    : insertDateFilter.from,
                  filterEntry[0] === 'InsertDate-To'
                    ? filterEntry[1]
                    : insertDateFilter.to
                );
                break;
              }
              case 'CreateDate-To':
              case 'CreateDate-From': {
                const createDateFilterIndex = noiseAlertsFilters
                  .map((item) => item.field)
                  .indexOf('CreateDate');
                const createDateFilter =
                  createDateFilterIndex !== -1
                    ? noiseAlertsFilters[createDateFilterIndex]
                    : {};

                upsertRangeFilter(
                  noiseAlertsFilters,
                  'CreateDate',
                  filterEntry[0] === 'CreateDate-From'
                    ? filterEntry[1]
                    : createDateFilter.from,
                  filterEntry[0] === 'CreateDate-To'
                    ? filterEntry[1]
                    : createDateFilter.to
                );
                break;
              }
              default: {
                noiseAlertsFilters.push({
                  field:
                    filterEntry[0] === 'ABC'
                      ? 'NoisePriority'
                      : filterEntry[0],
                  value:
                    filterEntry[0] === 'ABC'
                      ? mapAbcValuesToLabels(filterEntry[1], options.ABC || [])
                      : filterEntry[1],
                });
              }
            }
          });

          dispatch(actionsNoiseAlerts.setDefFilters(noiseAlertsDefFilters));
          dispatch(actionsNoiseAlerts.setFilters(noiseAlertsFilters));
        }

        dispatch(selectorsActions.sortSamples('SampleDateAndTime', 'desc'));
        dispatch(actionsCouples.sortCoupleSamples('SampleDateAndTime', 'desc'));

        // leak alerts
        let alertsDefFilters = {
          AlertState: defaultFilters,
          AlertType: alertTypeDefaultFilters,
          IntensityOpr: '=',
          ProbabilityOpr: '=',
          ProbabilityLeakOpr: '=',
          DetectedAtOpr: '=',
          sortBy: 'Priority',
          sortByDir: 'asc',
        };
        let filters = [
          { field: 'AlertState', value: defaultFilters, op: '=' },
          { field: 'AlertType', value: [0, 1] },
        ];
        if (localStorage[FILTERS_ALERTS]) {
          alertsDefFilters = JSON.parse(localStorage.getItem(FILTERS_ALERTS));
          filters = [];
          Object.entries(alertsDefFilters).forEach((filterEntry) => {
            if (
              [
                'IntensityOpr',
                'ProbabilityOpr',
                'ProbabilityLeakOpr',
                'DetectedAtOpr',
                'sortBy',
                'sortByDir',
                'showRanking',
              ].indexOf(filterEntry[0]) === -1
            ) {
              switch (filterEntry[0]) {
                case 'Intensity': {
                  filters.push({
                    field: filterEntry[0],
                    value: [filterEntry[1]],
                    op: alertsDefFilters.IntensityOpr || '=',
                  });
                  break;
                }
                case 'ProbabilityLeak': {
                  filters.push({
                    field: filterEntry[0],
                    value: [filterEntry[1]],
                    op: alertsDefFilters.ProbabilityLeakOpr || '=',
                  });
                  break;
                }
                case 'DetectedAt-To':
                case 'DetectedAt-From': {
                  const detectedFilterIndex = filters
                    .map((item) => item.field)
                    .indexOf('DetectedAt');
                  const detectedFilter =
                    detectedFilterIndex !== -1 ? filters[detectedFilterIndex] : {};

                  upsertRangeFilter(
                    filters,
                    'DetectedAt',
                    filterEntry[0] === 'DetectedAt-From'
                      ? filterEntry[1]
                      : detectedFilter.from,
                    filterEntry[0] === 'DetectedAt-To'
                      ? filterEntry[1]
                      : detectedFilter.to
                  );
                  break;
                }
                default: {
                  filters.push({
                    field: filterEntry[0],
                    value: filterEntry[1],
                  });
                  break;
                }
              }
            }
          });
        }

        if (localStorage[SORT_ALERTS]) {
          const sortAlerts = JSON.parse(localStorage.getItem(SORT_ALERTS));
          dispatch(actionsAlerts.setSortDetails(sortAlerts.field, sortAlerts.dir));
        }
        //leak
        dispatch(actionsAlerts.setFilters(filters));
        dispatch(actionsAlerts.setDefFilters(alertsDefFilters));


        // case burst alert: restore the user's saved filters, otherwise default
        // to the open statuses New / To Be Located / Monitoring (resolved from
        // the AlertStateNoise option names, see resolveBurstDefaultAlertStates).
        if (localStorage[FILTERS_BURST_ALERTS]) {
          const burstFilters = [];
          const burstAlertDefFilters = JSON.parse(localStorage.getItem(FILTERS_BURST_ALERTS));

          Object.entries(burstAlertDefFilters).forEach((filterEntry) => {
            if (['sortBy', 'sortByDir'].indexOf(filterEntry[0]) !== -1) {
              return;
            }
            switch (filterEntry[0]) {
              case 'create_date-To':
              case 'create_date-From': {
                const detectedFilterIndex = burstFilters
                  .map((item) => item.field)
                  .indexOf('create_date');
                const detectedFilter =
                  detectedFilterIndex !== -1 ? burstFilters[detectedFilterIndex] : {};

                upsertRangeFilter(
                  burstFilters,
                  'create_date',
                  filterEntry[0] === 'create_date-From'
                    ? filterEntry[1]
                    : detectedFilter.from,
                  filterEntry[0] === 'create_date-To'
                    ? filterEntry[1]
                    : detectedFilter.to
                );
                break;
              }
              default: {
                burstFilters.push({
                  field: filterEntry[0],
                  value: filterEntry[1],
                });
                break;
              }
            }
          });

          dispatch(setBurstFilters(burstFilters));
          dispatch(setBurstDefFilters(burstAlertDefFilters));
        } else {
          const burstDefaultStates = resolveBurstDefaultAlertStates(
            options && options.AlertStateNoise
          );
          dispatch(
            setBurstFilters([{ field: 'alert_state', value: burstDefaultStates }])
          );
          dispatch(setBurstDefFilters({ alert_state: burstDefaultStates }));
        }

        // case valve alert
        if (localStorage[FILTERS_VALVE_ALERTS]) {
          let valveFilters = [];
          const valveAlertDefFilters = JSON.parse(localStorage.getItem(FILTERS_VALVE_ALERTS));

          Object.entries(valveAlertDefFilters).forEach((filterEntry) => {
            if (
              [
                'sortBy',
                'sortByDir',
              ].indexOf(filterEntry[0]) == -1
            ) {
              switch (filterEntry[0]) {

                case 'create_date-To':
                case 'create_date-From': {
                  const detectedFilterIndex = valveFilters
                    .map((item) => item.field)
                    .indexOf('create_date');
                  const detectedFilter =
                    detectedFilterIndex !== -1 ? valveFilters[detectedFilterIndex] : {};

                  upsertRangeFilter(
                    valveFilters,
                    'create_date',
                    filterEntry[0] === 'create_date-From'
                      ? filterEntry[1]
                      : detectedFilter.from,
                    filterEntry[0] === 'create_date-To'
                      ? filterEntry[1]
                      : detectedFilter.to
                  );
                  break;
                }
                default: {
                  valveFilters.push({
                    field: filterEntry[0],
                    value: filterEntry[1],
                  });
                  break;
                }
              }
            }
          });

          //valve dispatch
          dispatch(setValveFilters(valveFilters));
          return dispatch(setValveDefFilters(valveAlertDefFilters));
        }
      })
      .catch((error) => {
      });
  };
}

//--------------------------------
// Settings
//--------------------------------
export const fetchCustomDetails = () => {
  return (dispatch, getState) => {
    const path = endPoints.END_POINT + '/customerDetails';
    return fetchMiddleware(path, {}, getState).then((json) => {
      return dispatch(receiveCustomDetails(json.data));
    });
  };
};

export const fetchImages = (getState, projectId, itemId, itemType) => {
  const path =
    endPoints.END_POINT +
    `/images/${projectId}?itemId=${itemId}&itemType=${itemType}`;
  return fetchMiddleware(path, {}, getState);
};

export function setEditMode(userData) {
  return {
    type: types.SET_EDIT_MODE,
    editMode: userData.canEdit,
    userEditMode: userData.canEditUsers,
    dashboard: userData.dashboard,
    dashboardSettings: userData.dashboardSettings,
    dashboardManager: userData.dashboardManager,
    dashboardMaintenance: userData.dashboardMaintenance,
    canAddAlert: userData.canAddAlert,
    isAQS: userData.isAQS,
    viewWaterMeter: userData.waterMeterAccess,
    analysesExpert: userData.graphsLables,
    installerPlanner: userData.installerPlanner,
    advancedMapIndications: userData.advancedMapIndications,
    uid: userData.userID,
    customerId: userData.customerId,
    isPCA: userData.isPCA,
    operatePcaModule: userData.operatePcaModule,
    technicianAdvanced: userData.technicianAdvanced,
    g5Operator: userData.g5Operator,
    g5Admin: userData.g5Admin,
    g5AqsAdmin: userData.g5AqsAdmin,
    mobile: userData.mobile,
    analysisExtends: userData.analysisExtends,
    valveAlerts: userData.valveAlerts,
  };
}

export function setUnit(unit) {
  return {
    type: types.SET_UNIT,
    unit,
  };
}

export function setPressureUnit(pressureUnit) {
  return {
    type: types.SET_PRESSURE_UNIT,
    pressureUnit,
  };
}

export function setZone(zone) {
  return {
    type: types.SET_ZONE,
    zone,
  };
}

export const editComment = (form, field) => {
  // TODO: REMOVE IF NOT USE
  return (dispatch) => {
    //dispatch(focusToCommentField(form, field));
    return dispatch(clearCommentField(form, field));
  };
};

export const copyComment = (form, field) => {
  // TODO: REMOVE IF NOT USE
  return (dispatch, getState) => {
    const state = getState();
    if (state.form[form] != null) {
      const value = state.form[form].values[field];
      dispatch(copy({ payload: { value } }));
      return true;
    }
    return true;
  };
};

const clearCommentField = (form, field) => {
  return {
    type: '@@redux-form/CHANGE',
    meta: {
      form: form,
      field: field,
      touch: false,
      persistentSubmitErrors: false,
    },
    payload: '',
  };
};

const focusToCommentField = (form, field) => {
  return {
    type: '@@redux-form/FOCUS',
    meta: { form: form, field: field },
  };
};
//--------------------------------
// Notification
//--------------------------------

export function clearNotification() {
  return {
    type: types.CLEAR_NOTIFICATION,
  };
}

//--------------------------------
// Intervaled Actions
//--------------------------------

export function updateState(time) {
  return {
    type: types.REFRESH_STATE,
    time,
  };
}

//--------------------------------
// Management Actions
//--------------------------------
export const changeManagementContext = (context) => {
  const action = {
    type: types.CHANGE_MANAGE_CONTEXT,
    context,
  };

  if (context != 'Projects') {
    return action;
  } else {
    // select the current project by default:
    return (dispatch, getState) => {
      const state = getState();
      const selectedProjectId = state.leaksList.selectedProject;
      const projectBundle = state.leaksList.projectsList;
      const selectedProject =
        projectBundle.items[projectBundle.projectIndexMap[selectedProjectId]];
      dispatch(action);
      //return dispatch(selectManageItem(selectedProject))
    };
  }
};


export const addNewManageItem = () => {
  return {
    type: types.ADD_NEW_MANAGE_ITEM,
  };
};

// ------------------------------------
// Google's Address
// ------------------------------------

export const initializeForm = (form, data) => {
  return reduxFormActions.initialize(form, data, false);
};

const saveTempAddressForItem = (
  selectedFeatureType,
  selectedFeatureID,
  address
) => {
  return {
    type: types.SAVE_TEMP_ADDRESS_FOR_ITEM,
    selectedFeatureType,
    selectedFeatureID,
    address,
  };
};

const getItemPositionForAddress = (state) => {
  let position = {};
  const path = state.routing.locationBeforeTransitions.pathname;

  if (state.mapState.drawMode.isActive) {
    if (state.mapState.drawMode.data != null) {
      const points = state.mapState.drawMode.data[0];
      position.lat = points[1];
      position.lng = points[0];
    }
  } else if (
    state.install.newInstallItem != null &&
    state.install.newInstallItem.id == -1
  ) {
    // in add SOP etc.
    const point = state.install.newInstallItem.position;
    if (point != null) {
      position.lat = point[1];
      position.lng = point[0];
    }
  } else {
    const selectedFeatureID = state.leaksList.leaksByProject.selectedFeature;
    const selectedFeatureType = state.leaksList.leaksByProject.selectedFeatureType;
    const selectedProjectID = state.leaksList.selectedProject;
    let item = null;
    switch (selectedFeatureType) {

      case featuresTypes.ALERT: {
        const projectAlerts = state.leaksList.leaksByProject[selectedProjectID].items;
        const projectAlertsIndexMap = state.leaksList.leaksByProject[selectedProjectID].indexMap;
        item = projectAlerts[projectAlertsIndexMap[selectedFeatureID]];
        break;
      }
      // check if needed todo lia
      case featuresTypes.MOBILE_ALERTS: {
        const projectMobileAlerts =
          state.mobile.alerts.items;
        const projectMobileAlertsIndexMap =
          state.mobile.alerts.indexMap;
        item = projectMobileAlerts[projectMobileAlertsIndexMap[selectedFeatureID]];
        break;
      }
      case featuresTypes.SENSOR: {
        const projectSenosors =
          state.leaksList.leaksByProject[selectedProjectID].sensors.sensors;
        const projectSensorsIndexMap =
          state.leaksList.leaksByProject[selectedProjectID].sensors.indexMap;
        item = projectSenosors[projectSensorsIndexMap[selectedFeatureID]];
        if (!item) {
          const pressureSensorsData =
            state.leaksList.leaksByProject[selectedProjectID].sensors.pressureSensors;
          if (pressureSensorsData) {
            item = pressureSensorsData.items[pressureSensorsData.indexMap[selectedFeatureID]];
          }
        }
        break;
      }
      case featuresTypes.SOP: {
        const projectSOPs =
          state.leaksList.leaksByProject[selectedProjectID].sops.sops;
        const projectSOPsIndexMap =
          state.leaksList.leaksByProject[selectedProjectID].sops.indexMap;
        item = projectSOPs[projectSOPsIndexMap[selectedFeatureID]];
        break;
      }
      case featuresTypes.PRESSURE_SENSOR: {
        const pressureSensors =
          state.leaksList.leaksByProject[selectedProjectID].sensors.pressureSensors;
        item = pressureSensors.items[pressureSensors.indexMap[selectedFeatureID]];
        break;
      }
      case featuresTypes.MOBILE_ALERT: {

        const projectMobileAlerts = state.mobile.alerts.items;
        const projectMobileAlertsIndexMap = state.mobile.alerts.indexMap;
        item = projectMobileAlerts[projectMobileAlertsIndexMap[selectedFeatureID]];
        break;
      }
      default:
        break;
    }

    if (path === 'mobile') {

      position.lat = item?.latitude;
      position.lng = item?.longitude;
    } else {
      position.lat = item.Latitude;
      position.lng = item.Longitude;
    }
  }

  return position;
};

export const getAddressByLatLong = (form, field) => {
  return (dispatch, getState) => {
    const state = getState();
    const selectedFeatureID = state.leaksList.leaksByProject.selectedFeature;
    const selectedFeatureType =
      state.leaksList.leaksByProject.selectedFeatureType;
    let languageKey = state.i18nState.lang;

    const position = getItemPositionForAddress(state);

    if (position != null && position.lat != null && position.lng != null) {
      if (languageKey == null) {
        languageKey = 'en';
      }
      return dispatch(
        coordinatesToAddress(
          { Latitude: position.lat, Longitude: position.lng },
          (address) => {
            dispatch(
              saveTempAddressForItem(
                selectedFeatureType,
                selectedFeatureID,
                address
              )
            );
            return dispatch(
              // setFieldText(form, field, address.FormattedAddress)
              setFieldText(form, field, address)
            );
          }
        )
      );
      //const path = endPoints.END_POINT + '/lat/' + latitude + '/lng/' + longitude + '/lang/' + languageKey + '/getAddress';
      //return fetchMiddleware(path, {}, getState).then(json => {
      //  return dispatch(setFieldText(form, field, json.data.formattedAddress));
      //});
    }
  };
};

export const searchAddress = (addressToSearch, callback) => {
  return (dispatch, getState) => {
    const Coordinates = require('coordinate-parser');
    try {
      // for case that addressToSearch input is already coordinate:
      const position = new Coordinates(addressToSearch);
      callback({ lat: position.getLatitude(), lng: position.getLongitude() });
      // return plane action-object for the rudux documentation of dispatched function
      return { type: 'search success by coordinate' };
    } catch (error) {
      geocoder.findPositionByAddress(addressToSearch, callback, dispatch, getState);
    }
  };
};

//https://nominatim.openstreetmap.org/reverse?format=xml&lat=32.293197&lon=34.863215&zoom=14&addressdetails=0

/**
 * 
 * @param {{Latitude: number, Longitude: number}} coordinates { Latitude, Longitude }
 * @param {(address: string) => void} cb callback function to handle the response
 */
export const coordinatesToAddress = (coordinates, cb) => {
  return (_dispatch, getState) => {
    const language = getState().i18nState.lang;
    const { Latitude, Longitude } = coordinates;
    const urlmapbox = endPoints.END_POINT + `/address/reverse/mapbox?lat=${Latitude}&lng=${Longitude}&language=${language}`;
    let addressData = null;
    fetchMiddleware(urlmapbox, {}, getState).then((json) => {
      if(json.data.address) {
        console.log("Mapbox Address");
        cb(json.data.address);
        
      } else {
        addressData = json.data;
        const urlgoogle = endPoints.END_POINT + `/address/reverse/google?latlng=${Latitude},${Longitude}&language=${language}`;
        fetchMiddleware(urlgoogle, {}, getState).then((json) => {
          if(json.address.includes('Unnamed Road')) {
            console.log("Google Address is Unnamed Road, return plus code");
            cb(`${addressData.plusCode}${addressData.city? ', ' + addressData.city : ''}${addressData.country? ', ' + addressData.country : ''}`);
          } else {
          console.log("Google Address");
          cb(json.address);
          }
        }).catch(() => cb(`${addressData.plusCode}${addressData.city? ', ' + addressData.city : ''}${addressData.country? ', ' + addressData.country : ''}`));
      }
    });
  };
};

export const getSignedUrlForFile = (bucket, key, cb) => (dispatch, getState) => {

  const path = `${endPoints.END_POINT}/signedfile?bucket=${bucket}&key=${key}`;
  return fetchMiddleware(path, {}, getState).then((json) => cb(json));
}

export const addExceptionalItem = (newItem) => (dispatch, getState) => {
  const state = getState();
  const projectId = state.leaksList.selectedProject;
  const path = state.routing.locationBeforeTransitions.pathname.replace('/', '') || 'alerts';

  switch (path) {
    case 'alerts': {
      const alertsContext = state.leaksList.pressure.context;

      if (alertsContext === 'noise') {
        dispatch(actionsNoiseAlerts.addExceptionalNoiseAlert(newItem));
        break;
      }

      const items = [newItem, ...state.leaksList.leaksByProject[projectId].items];
      const indexMap = setIndexes(items, 'id');
      const icons = getIconFeatures('leaks', items);
      dispatch(actionsAlerts.receiveLeaks(projectId, items, icons, indexMap))
      setTimeout(() => {
        dispatch(actionsAlerts.selectAlert(newItem))
      }, 1000);
      break;
    }

    case 'sensors': {
      const items = [newItem, ...state.leaksList.leaksByProject[projectId].sensors.sensors];
      const indexMap = setIndexes(items, 'id');
      const icons = getIconFeatures('sensors', items);
      dispatch(actionsSensors.receiveSensors(projectId, items, icons, indexMap))
      setTimeout(() => {
        dispatch(actionsSensors.selectSensor(newItem));
      }, 1000);
      break;
    }
  }
}
